<ion-content>
  <div id="imageformatting">
    <img src="assets/Columbia Protocol Logo.svg" style="width: 120px; height: 120px;" alt="Columbia Protocol Logo" />
  </div>

  <div style="padding-right: 10px; padding-left: 10px;">
      <ion-card-title id="header">
        What is Columbia Protocol?
      </ion-card-title>

      <ion-card>
        <p id="paragraph">
          The Columbia Protocol, also known as the Columbia-Suicide Severity Rating Scale (C-SSRS), supports suicide risk screening through a series of simple, plain-language questions that anyone can ask. The answers help users identify whether someone is at risk for suicide, determine the severity and immediacy of that risk, and gauge the level of support that the person needs. Users of the tool ask people:
        </p>

        <ul id="bulletpoints">
          <li>Whether and when they have thought about suicide (ideation)</li>
          <li>What actions they have taken — and when — to prepare for suicide</li>
          <li>Whether and when they attempted suicide or began a suicide attempt that was either interrupted by another person or stopped of their own volition</li>
        </ul>
      </ion-card>

      <div style="padding-top: 1px;">
        <ion-card id="header">
          <ion-card-title style="padding-bottom: 8px;">
            Want to learn more or get help?
          </ion-card-title>

          <ion-card-title>
            Download the Columbia Protocol app for free!
          </ion-card-title>
        </ion-card>

        <div style="padding-top: 5px;">
          <ion-button
            *ngFor="let button of buttons"
            shape="round"
            class="flex justify-center"
            style="margin-bottom: 10px;"
            [href]="button.link"
          >
            <ion-label> {{ button.label }} </ion-label>
          </ion-button>
        </div>
      </div>
  </div>
</ion-content>